
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.2 3.53V.587l1.018 1.03C2.12.618 3.43 0 4.854 0 7.59 0 9.8 2.236 9.8 5s-2.21 5-4.946 5a4.896 4.896 0 01-3.549-1.53l.814-.852a3.714 3.714 0 002.735 1.205C6.95 8.823 8.636 7.118 8.636 5S6.949 1.177 4.854 1.177A3.85 3.85 0 002.033 2.44L3.109 3.53H.2z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    